import * as React from "react";
import {DragDropContext} from "react-beautiful-dnd";
import {
    TabOrderWidget,
    DNDResult,
    TAB_ORDER_ENABLED,
    TAB_ORDER_REMOVED,
    DroppableId
} from "ui/experience/widgets/toolbox/TabOrder/TabOrderDndTypes";
import {DraggableColumnComponent} from "@zmags/zmags-ui-library";

const dndStyle: React.CSSProperties = {
    padding: "0px",
};

interface TabOrderProps extends React.Attributes {
    widgets: TabOrderWidget[];
    removedWidgets?: TabOrderWidget[];
    orderEnabled: boolean;
    selectedId?: string;
    onItemRemove: (id: string, columnId: string, insertIndex?: number) => void;
    onDragEnd: (columnId?: string, oldIndex?: number, newIndex?: number) => void;
    onDragStart: (widgetId: string) => void;
    onDragCancel: (widgetId: string) => void;
}

class TabOrderComponent extends React.Component<TabOrderProps> {
    _onDragCancel = (widgetId: string) => {
        this.props.onDragCancel(widgetId);
    }

    /**
     * This is onDragEnd handler
     * onDragEnd DragDropContext has been used
     */
    onDragEnd = (result: DNDResult) => {
        const { destination, source } = result;
        const isRemoval = !!destination && destination.droppableId !== source.droppableId;
        if(isRemoval) {
            const target = source.droppableId === TAB_ORDER_ENABLED ?
                this.props.widgets[source.index] : this.props.removedWidgets[source.index];
            this.props.onItemRemove(target.id, source.droppableId, destination.index);
        } else if (!destination ||
           ( destination.droppableId === source.droppableId
        && destination.index === source.index)) {
            // Just return empty call if:
            // We have no destination - widget has been dropped outside of component
            // position of widget hasn't changed
            this.props.onDragEnd();
        } else {
            this.props.onDragEnd(source.droppableId, source.index, destination.index);
        }
    }

    onWidgetRemove = (widgetId: string, columnId: DroppableId) => {
        this.props.onItemRemove(widgetId, columnId);
    }

    render() {
        const {orderEnabled, widgets, removedWidgets, selectedId, onDragStart} = this.props;

        return (
            <div style={dndStyle}>
                { orderEnabled &&
                    <DragDropContext onDragEnd={this.onDragEnd}>
                        <DraggableColumnComponent
                            items={widgets}
                            columnId={TAB_ORDER_ENABLED}
                            label="Tab order"
                            onDragStart={onDragStart}
                            onRemoveItem={this.onWidgetRemove}
                            onDragCancel={this._onDragCancel}
                            selectedId={selectedId}
                            changeIcon="&times;"
                            ignoredOutsideClickClassName="layer-drag-wrapper"
                        />
                        <DraggableColumnComponent
                            items={removedWidgets}
                            columnId={TAB_ORDER_REMOVED}
                            label="Removed from tab order"
                            onDragStart={onDragStart}
                            onRemoveItem={this.onWidgetRemove}
                            onDragCancel={this._onDragCancel}
                            selectedId={selectedId}
                            changeIcon="+"
                            ignoredOutsideClickClassName="layer-drag-wrapper"
                        />
                    </DragDropContext>
                }
            </div>
        );
      }
}

export {
    TabOrderComponent as default
};



// WEBPACK FOOTER //
// ./src/editor/ui/experience/widgets/toolbox/TabOrder/TabOrderComponent.tsx